import http from "./httpService";

function getIncidents(location) {
  return http.get(`/stores/${location}/incidents/`).then((response) => response.data);
}

export default getIncidents;
